import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LBtn } from "../../../common/components/LBtn";
import { LTitle } from "../../../common/components/LTitle";
import { toggleFullScreenOn } from "../../../common/helpers/fullScreenHelper";
import { NavItems } from "../../../common/helpers/navigation";
import { AssessmentShell } from "../components/AssessmentShell";
import { Translate } from "react-i18nify";
import { useAppSelector } from "../../../app/hooks";

export const AssessmentStart = (): JSX.Element => {
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const assessmentForm = useAppSelector((x) => x.assessmentForm);
    const waitForCacheVideos = 5000;

    useEffect(() => {
        const interval = setInterval(() => {
            setIsLoading(false);
        }, waitForCacheVideos);

        return () => clearInterval(interval);
    }, []);

    const handleStart = async (): Promise<void> => {
        await toggleFullScreenOn();
        navigate(NavItems.Assessments.PracticeInstruction.path);
    };

    return (
        <AssessmentShell excludeUnauthenticatedMenu>
            {assessmentForm.instructions.map((x) => (
                <link key={x.stepName} rel="prefetch" href={x.instructionVideoUrl} as="video" type="video/mp4"></link>
            ))}

            <div>
                <LTitle color="has-text-dark-blue">
                    <Translate value="assessments.rstart" />
                </LTitle>

                <div className="my-6">
                    <LBtn onClick={handleStart} isBold loading={isLoading}>
                        <Translate value="assessments.start" />
                    </LBtn>
                </div>
            </div>
        </AssessmentShell>
    );
};
